export function shouldShowAgentDiagnostics(): boolean {
  const value = process.env.NEXT_PUBLIC_SHOW_AGENT_DIAGNOSTICS;
  return value === '1' || value === 'true';
}
